import { render, staticRenderFns } from "./public.vue?vue&type=template&id=37cbdd59&"
import script from "./public.vue?vue&type=script&lang=js&"
export * from "./public.vue?vue&type=script&lang=js&"
import style0 from "./public.vue?vue&type=style&index=0&id=37cbdd59&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports